var React = require('react');

function IcError (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M31.973 5.333C17.253 5.333 5.333 17.28 5.333 32c0 14.72 11.92 26.667 26.64 26.667C46.72 58.667 58.667 46.72 58.667 32c0-14.72-11.947-26.667-26.694-26.667zm2.694 29.334v-16h-5.334v16h5.334zm0 10.666V40h-5.334v5.333h5.334zM10.667 32c0 11.787 9.546 21.333 21.333 21.333 11.787 0 21.333-9.546 21.333-21.333 0-11.787-9.546-21.333-21.333-21.333-11.787 0-21.333 9.546-21.333 21.333z","fill":"currentColor"}));
}

IcError.defaultProps = {"fill":"none","viewBox":"0 0 64 64"};

module.exports = IcError;

IcError.default = IcError;
